(function () {
	const flyout = document.querySelector("[data-floating-video-thumb]");
	if (!flyout) return;

	const thumbVideo = flyout.querySelector("[data-video-thumb]");
	const playButton = flyout.querySelector("[data-video-play]");
	const closeButton = flyout.querySelector("[data-video-close]");
	const videoSrc = flyout.getAttribute("data-video-src");
	const videoPoster = flyout.getAttribute("data-video-poster");
	const loopSeconds = Number(
		thumbVideo?.getAttribute("data-loop-seconds") || 3,
	);

	const addVisibleState = () => {
		requestAnimationFrame(() => {
			flyout.classList.add("is-visible");
		});
	};

	const closeFlyout = () => {
		flyout.classList.add("is-closed");
		if (thumbVideo) {
			thumbVideo.pause();
		}
	};

	const escHandler = (evt) => {
		if (evt.key === "Escape") {
			removeLightbox();
		}
	};

	const removeLightbox = () => {
		const lightbox = document.querySelector(".t4s-video-lightbox");
		if (!lightbox) return;
		const lightboxVideo = lightbox.querySelector("video");
		if (lightboxVideo) {
			lightboxVideo.pause();
		}
		lightbox.remove();
		document.body.classList.remove("t4s-video-lightbox-open");
		document.removeEventListener("keydown", escHandler);
	};

	const openLightbox = (autoplayOnLoad = false) => {
		if (!videoSrc) return;
		removeLightbox();
		const wrapper = document.createElement("div");
		wrapper.className = "t4s-video-lightbox";
    //const mutedAttr = autoplayOnLoad ? "muted" : "";
		const mutedAttr = autoplayOnLoad ? "muted" : "";
		wrapper.innerHTML = [
			'<div class="t4s-video-lightbox__backdrop" data-lightbox-close></div>',
			'<div class="t4s-video-lightbox__dialog">',
			'  <button type="button" class="t4s-video-lightbox__close" data-lightbox-close aria-label="Close video">',
			'    <svg viewBox="0 0 16 16" aria-hidden="true"><path d="M2 2l12 12M14 2L2 14" stroke="currentColor" stroke-width="2" fill="none" stroke-linecap="round"/></svg>',
			"  </button>",
			`  <video class="t4s-video-lightbox__video" playsinline controls autoplay ${mutedAttr} ${videoPoster ? `poster="${videoPoster}"` : ""}>`,
			`    <source src="${videoSrc}">`,
			"    Your browser does not support the video tag.",
			"  </video>",
			"</div>",
		].join("");

		document.body.appendChild(wrapper);
		document.body.classList.add("t4s-video-lightbox-open");

		const lbVideo = wrapper.querySelector("video");
		if (lbVideo) {
			lbVideo.addEventListener("loadedmetadata", () => {
				lbVideo.play().catch(() => {});
			});
			// Fallback immediate play attempt
			lbVideo.play().catch(() => {});
		}

		wrapper.addEventListener("click", (event) => {
			const closeTarget = event.target.closest("[data-lightbox-close]");
			const shouldClose =
				closeTarget ||
				event.target.classList.contains("t4s-video-lightbox__backdrop");
			if (shouldClose) {
				removeLightbox();
			}
		});

		document.addEventListener("keydown", escHandler);
	};

	const primeThumbVideo = () => {
		if (!thumbVideo) return;
		thumbVideo.muted = true;
		thumbVideo.playsInline = true;
		thumbVideo.loop = false;
		thumbVideo.addEventListener("timeupdate", () => {
			if (thumbVideo.currentTime >= loopSeconds) {
				thumbVideo.currentTime = 0;
				thumbVideo.play().catch(() => {});
			}
		});
		thumbVideo.addEventListener("loadeddata", () => {
			thumbVideo.play().catch(() => {});
		});
		thumbVideo.play().catch(() => {});
	};

	if (closeButton) {
		closeButton.addEventListener("click", (event) => {
			event.stopPropagation();
			closeFlyout();
		});
	}

	if (playButton) {
		playButton.addEventListener("click", (event) => {
			event.preventDefault();
			openLightbox();
		});
	}

	if (thumbVideo) {
		thumbVideo.addEventListener("click", () => {
			openLightbox();
		});
	}

	primeThumbVideo();
	addVisibleState();

	// Autoplay the product video in the lightbox on page load
	/* if (videoSrc) {
		setTimeout(() => {
			openLightbox(true);
		}, 100);
	} */
})();
